<template>
  <div class="main" id="main">
    <my-header></my-header>
    <div
      class="content"
      v-infinite-scroll="load"
      infinite-scroll-disabled="disabled"
      style="overflow: auto"
    >
      <div class="panoExample"></div>
      <div class="list">
        <div class="items">
          <router-link
            :to="'/sceneView?id=' + value.id"
            class="li infinite-list-item"
            v-for="value in data"
            :key="value.id"
            target="_blank"
          >
            <div class="item">
              <div class="item-top">
                <div
                  class="item-img"
                  :style="'background-image:url(' + value.iconUrl + ')'"
                ></div>
                <div class="pad"></div>
              </div>
              <div class="item-foot">
                <div class="item-foot-left">{{ value.name }}</div>
                <!-- <div class="item-foot-right">{{ value.name }}</div> -->
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <p v-if="noMore" class="nomore">没有更多了</p>
      <div class="loading" v-if="loading">
        <div v-loading="true" :fullscreen="false"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.main {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f2f2f2;
  /* color: white; */
}
.content {
  height: 100vh;
  width: 100%;
  position: relative;
  padding-bottom: 455px;
  overflow: auto;
  transform: translate(0);
}
.panoExample {
  height: 400px;
  width: 100%;
  position: relative;
  background: url(../../public/imgs/common/bg2.jpg) repeat center;
  background-size: cover;
}
.list {
  width: 84%;
  margin: 65px auto 0;
}
.items {
  display: flex;
  flex-wrap: wrap;
  perspective: 1000px;
  width: calc(100% + 30px);
  transform: translateX(-15px);
}
.li {
  width: calc(33.33333% - 31px);
  margin: 0 15px 30px;
  flex: none;
  cursor: pointer;
}
.item {
  /* height: 250px; */
  width: 100%;
  box-shadow: 0 1px 1px rgb(97 108 121 / 10%),
    0 7px 18px 0 rgb(97 108 121 / 13%);
  transition: box-shadow 0.2s ease;
  position: relative;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 3px;
}
.item:hover {
  box-shadow: 0 1px 1px rgb(97 108 121 / 10%),
    0 7px 18px 0 rgb(21 111 170 / 21%);
}
.pad {
  padding-top: 56.25%;
}
.item-top {
  position: relative;
}
.item-img {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  
}
.nomore {
  text-align: center;
}
.loading {
  margin-bottom: 65px;
}
.item-foot {
  display: flex;
  height: 48px;
  padding: 12px;
  align-items: center;
  background-color: white;
  box-sizing: border-box;
}

.item-foot-left {
  font-size: 12px;
  min-width: 0;
  margin-right: 6px;
  max-width: 100%;
  overflow: hidden;
  font-weight: 600;
  line-height: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  flex: 1;
  color: #555;
}
</style>
<script>
import https from "@/https.js";
import MyHeader from "@/components/header.vue";
export default {
  components: {
    MyHeader: MyHeader,
  },
  data() {
    return {
      id: "2",
      headShow: false,
      data: [],
      currentPage: 0,
      currentSize: 15,
      canScroll: true,
      loading: false,
    };
  },
  computed: {
    noMore() {
      return !this.canScroll;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  created() {
    //this.init();
  },
  mounted() {},
  methods: {
    init() {
      https
        .fetchGet("/GetPublicBaseSceneInfo", {
          pageIndex: this.currentPage,
          pageSize: this.currentSize,
        })
        .then((res) => {
          if (res.data.result.length == 0) {
            this.canScroll = false;
          }
          // let arr = res.data.result[0];
          // for (let i = 0; i < 15; i++) {
          //   res.data.result.push(res.data.result[0]);
          // }
          this.data = [...this.data, ...res.data.result];
          this.loading = false;
          console.log(this.canScroll);
          console.log(this.data);
        });
    },

    load() {
      this.loading = true;
        this.currentPage++;
        setTimeout(() => {
          this.init();
        }, 1000);
    },
    back() {},
  },
};
</script>
